import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { InputCalendarComponent } from './input-calendar.component';
import { FileUploadModule } from '@components/shared/file-upload';
import { PipesModule } from '../../../../pipes/pipes.module';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { NgxMyDatePickerModule } from '../../ngx-my-date-picker';

@NgModule({ declarations: [InputCalendarComponent],
    exports: [InputCalendarComponent], imports: [CommonModule,
        FormsModule,
        PipesModule,
        FormsModule,
        FileUploadModule,
        ReactiveFormsModule,
        NgxMaskDirective,
        NgxMyDatePickerModule], providers: [provideNgxMask(), provideHttpClient(withInterceptorsFromDi())] })

export class InputCalendarModule {
}
